export enum Mode {
    BASIC = 'BASIC',
    ENHANCED = 'ENHANCED',
}
